import script from "./DropDown.vue?vue&type=script&lang=ts&setup=true"
export * from "./DropDown.vue?vue&type=script&lang=ts&setup=true"

import "./DropDown.vue?vue&type=style&index=0&id=2dec5d42&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dec5d42"]])

export default __exports__